import { ImportItemStatus } from '@synergy/models';

const translationObject: { [Key in ImportItemStatus]: string } = {
    [ImportItemStatus.Created]: 'app.ImportItemStatus.created',
    [ImportItemStatus.Failed]: 'app.ImportItemStatus.failed',
    [ImportItemStatus.Published]: 'app.ImportItemStatus.published',
    [ImportItemStatus.Publishing]: 'app.ImportItemStatus.publishing',
    [ImportItemStatus.Warning]: 'app.ImportItemStatus.warning',
    [ImportItemStatus.NotPublished]: 'app.ImportItemStatus.notPublishing',
    [ImportItemStatus.ReadyToPublish]: 'app.ImportItemStatus.readyToPublish',
    [ImportItemStatus.Receiving]: 'app.ImportItemStatus.receiving',
};

export const getImportItemStatusTranslationId = (status: ImportItemStatus): string => {
    return (status && translationObject[status]) || status.toString();
};
